export class Globals
{
  public static mode: string;
}



// WEBPACK FOOTER //
// ./src/app/core/globals.ts